import { useEffect, useState } from 'react';
import { useAgentVisitorDeliveryIdentifiers } from '../../../delivery-identifiers/public/hooks';
import { fetchMessageLimitData } from '../clients/fetchMessageLimitData';
import { trimVisitorDeliveryIdentifiersForQuotaRequest } from '../operators/trimVisitorDeliveryIdentifiersForQuotaRequest';
import Raven from 'raven-js';
export const useMessageLimitData = ({
  threadId,
  genericChannelId,
  deferred
}) => {
  const [messageLimitData, setMessageLimitData] = useState(null);
  const {
    loading,
    error: fetchDeliveryIdentifiersError,
    threadAgentDeliveryIdentifierData,
    threadVisitorDeliveryIdentifiersData
  } = useAgentVisitorDeliveryIdentifiers({
    threadId,
    genericChannelId
  });
  useEffect(() => {
    if (!deferred) {
      const agentDeliveryIdentifier = threadAgentDeliveryIdentifierData ? threadAgentDeliveryIdentifierData.deliveryIdentifier : undefined;
      const visitorDeliveryIdentifiers = threadVisitorDeliveryIdentifiersData ? threadVisitorDeliveryIdentifiersData.map(d => d.deliveryIdentifier) : undefined;
      if (agentDeliveryIdentifier && visitorDeliveryIdentifiers) {
        const trimmedVisitorDeliveryIdenifierList = trimVisitorDeliveryIdentifiersForQuotaRequest(visitorDeliveryIdentifiers);
        fetchMessageLimitData({
          genericChannelId,
          agentDeliveryIdentifier,
          visitorDeliveryIdentifiers: trimmedVisitorDeliveryIdenifierList
        }).then(resp => {
          setMessageLimitData({
            conversationExpiresAt: resp.conversationExpiresAt,
            sessionExpiresAt: resp.messageTypeExpiresAt,
            usage: resp.usage,
            limit: resp.limit,
            availableSendStatus: resp.sessionQuotaAllowedMessageType,
            limitStatus: resp.sessionQuotaMessageLimitStatus,
            newestThreadId: resp.threadId ? `${resp.threadId}` : undefined
          });
        }).catch(error => {
          Raven.captureException(new Error(`Error in fetching conversation session quota: ${error.message}`), {
            fingerprint: ['SESSION_QUOTA', error.status],
            extra: {
              requestArgs: {
                genericChannelId,
                agentDeliveryIdentifier,
                visitorDeliveryIdentifiers
              },
              threadId
            }
          });
        });
      } else if (!loading) {
        Raven.captureException(new Error(`Error in fetching conversation session quota: delivery identifers not found`), {
          extra: {
            requestArgs: {
              genericChannelId,
              agentDeliveryIdentifier,
              visitorDeliveryIdentifiers,
              fetchDeliveryIdentifiersError: `${fetchDeliveryIdentifiersError}`
            },
            threadId
          }
        });
        setMessageLimitData(null);
      }
    } else {
      setMessageLimitData(null);
    }
  }, [loading, fetchDeliveryIdentifiersError, genericChannelId, threadAgentDeliveryIdentifierData, threadId, threadVisitorDeliveryIdentifiersData, deferred]);
  return {
    messageLimitData
  };
};